/*
  Atlanticus / Kolektif Tasarım — SHOP+ mega menu controller.

  Behaviour (matches design reference):
    - mouseenter on the SHOP+ trigger opens the panel
    - clicking the trigger toggles the panel
    - leaving the whole header closes it
    - hovering anywhere within the header keeps it open

  Visibility is driven purely by adding/removing the `is-open` class which flips
  `display:none` -> `block` plus the transform-only @keyframes atl-drop animation
  defined in atlanticus-base.css. We intentionally do NOT gate visibility on
  opacity (README gotcha: background tabs throttle CSS animations and an
  opacity-only panel could remain invisible).
*/

class AtlMegaMenu extends HTMLElement {
  constructor() {
    super();
    this._onTriggerEnter = this._onTriggerEnter.bind(this);
    this._onTriggerClick = this._onTriggerClick.bind(this);
    this._onHeaderLeave = this._onHeaderLeave.bind(this);
    this._onKeydown = this._onKeydown.bind(this);
  }

  connectedCallback() {
    this.trigger = this.querySelector('[data-mega-trigger]');
    this.panel = this.querySelector('[data-mega-panel]');
    if (!this.trigger || !this.panel) return;

    this.trigger.addEventListener('mouseenter', this._onTriggerEnter);
    // Sadece hover: click-toggle kaldırıldı (ÜRÜNLER de yalnız hover ile açılır/kapanır).
    // Close when the pointer leaves the entire header shell.
    this.addEventListener('mouseleave', this._onHeaderLeave);
    // KEŞFET (CSS hover dropdown) ile çakışma: imleç Keşfet'e geçince mega kapanır
    // (yoksa iki panel üst üste açık kalıyordu).
    this._onDiscoverOver = (e) => { if (e.target.closest('.atl-discover') || e.target.closest('.atl-gift')) this.close(); };
    this.addEventListener('mouseover', this._onDiscoverOver);
    document.addEventListener('keydown', this._onKeydown);
  }

  disconnectedCallback() {
    if (this.trigger) {
      this.trigger.removeEventListener('mouseenter', this._onTriggerEnter);
    }
    this.removeEventListener('mouseleave', this._onHeaderLeave);
    if (this._onDiscoverOver) this.removeEventListener('mouseover', this._onDiscoverOver);
    document.removeEventListener('keydown', this._onKeydown);
  }

  get isOpen() {
    return this.panel.classList.contains('is-open');
  }

  open() {
    if (this.isOpen) return;
    this.panel.classList.add('is-open');
    this.trigger.classList.add('is-open');
    this.trigger.setAttribute('aria-expanded', 'true');
  }

  close() {
    if (!this.isOpen) return;
    this.panel.classList.remove('is-open');
    this.trigger.classList.remove('is-open');
    this.trigger.setAttribute('aria-expanded', 'false');
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  _onTriggerEnter() {
    this.open();
  }

  _onTriggerClick(event) {
    event.preventDefault();
    this.toggle();
  }

  _onHeaderLeave() {
    this.close();
  }

  _onKeydown(event) {
    if (event.key === 'Escape' && this.isOpen) {
      this.close();
      if (this.trigger) this.trigger.focus();
    }
  }
}

if (!customElements.get('atl-mega-menu')) {
  customElements.define('atl-mega-menu', AtlMegaMenu);
}
